import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";

export const ProductionChainStepContentStyled = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "production-chain-step-content",
  },
)`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 10px;
  margin-inline-start: 10px;
`;

export const ProductionChainStepBlock = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "production-chain-step-block",
})`
  display: flex;
  flex-direction: column;
`;
